module.exports = __webpack_public_path__ + "static/media/img_17.910da438.png";